import React from 'react' 
import Bredcom from '../Bredcom/Main' 
import Header from '../headerone/Main' 


 
function AntiRaggingCommittees() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="Anti Ragging Committees" />
        <section className="project-detail">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="text-column col-lg-12 col-md-12 col-sm-12">                               
                                <div className="inner-column">
                                    <h2>Anti Ragging Committees</h2>
                                    <table className="table table-bordered mb-40">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                                <th>Contact No.</th>
                                                <th>Mail. Id</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Ashutosh Upadhayay</td>
                                                <td>Chairperson</td>
                                                <td>9887769310</td>
                                                <td>dr.ashutoshupadhayay@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Tehsildar, Hodal</td>
                                                <td>Representative of Civil Administration</td>
                                                <td>----</td>
                                                <td>----</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>SHO, Mundkati</td>
                                                <td>Representative Of Police Administration</td>
                                                <td>-----</td>
                                                <td>-----</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Dr. Ramveer Singh</td>
                                                <td>Member</td>
                                                <td>9968795577</td>
                                                <td>ramveer.singh@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Dr. Daya Shankar Prasad</td>
                                                <td>Member</td>
                                                <td>9650608199</td>
                                                <td>dayashankar.prasad@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>Dr. Amit Sagu</td>
                                                <td>Member</td>
                                                <td>9467702051</td>
                                                <td>amit.sagu@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>Dr. Kaushal Khatana</td>
                                                <td>Member</td>
                                                <td>9319922703</td>
                                                <td>kaushal.khatana@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Dr. Shrivardhan Dheeman</td>
                                                <td>Member</td>
                                                <td>8958242871</td>
                                                <td>shrivardhan.dheeman@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>9</td>
                                                <td>Ms. Nitika Roy</td>
                                                <td>Member</td>
                                                <td>8447617085</td>
                                                <td>nitika.roy@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>10</td>
                                                <td>Ms. Sakshi</td>
                                                <td>Member</td>
                                                <td>8708831949</td>
                                                <td>sakshi.garg@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>11</td>
                                                <td>Dr. Saraswati</td>
                                                <td>Member</td>
                                                <td>8683898646</td>
                                                <td>saraswati.sbmc@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>12</td>
                                                <td>Dr. Kuldeep</td>
                                                <td>Member</td>
                                                <td>9050644274</td>
                                                <td>Kuldeep.tanwar@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>13</td>
                                                <td>Ms. Poonam</td>
                                                <td>Member</td>
                                                <td>7015370582</td>
                                                <td>poonam.dagar@mvn.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>14</td>
                                                <td>Ms. Suman</td>
                                                <td>Member</td>
                                                <td>9992192656</td>
                                                <td>suman.indora@mvn.edu.in</td>
                                            </tr>
                                           <tr>
                                                <td>15</td>
                                                <td>Mr. ahender Singh</td>
                                                <td>Member</td>
                                                <td>9050130983</td>
                                                <td>mahender.singh@mvn.edu.in</td>                                           
                                           </tr>
                                           <tr>
                                                <td>16</td>
                                                <td>Mr. Ram Kumar (DPE)</td>
                                                <td>Member</td>
                                                <td>8397979266</td>
                                                <td>ram.kumar@mvn.edu.in</td>   
                                           </tr>
                                           <tr>
                                                <td>17</td>
                                                <td>Mr. Madhukar Kant 24SL4001</td>
                                                <td>Student Representative</td>
                                                <td>------</td>
                                                <td>------</td>                                             
                                           </tr>
                                           <tr>
                                                <td>18</td>
                                                <td>Mr. Hansdeep 23SL4002</td>
                                                <td>Student Representative</td>
                                                <td>------</td>
                                                <td>------</td>   
                                           </tr>
                                           <tr>
                                                <td>19</td>
                                                <td>Ms. Rutendo Nancy Chauramuyi 24SL2060</td>
                                                <td>Student Representative</td>
                                                <td>------</td>
                                                <td>------</td>   
                                           </tr> 
                                           <tr>
                                                <td>20</td>
                                                <td>Dy. Registrar</td>
                                                <td>Member Secretary</td>
                                                <td>9991978122</td>
                                                <td>dy.registrar@mvn.edu.in</td>   
                                           </tr>  
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        
    </> 
  ) 
} 
 
export default AntiRaggingCommittees 